


export const responseToSelect = (data) => data?.map((option)=>({
    value: option.id, label: option.name
}))